<script setup>

const props = defineProps({
  location: Object,
  showPromoBanner: Boolean  
})

const { version } = useZigZag()
const config = useRuntimeConfig()
const { data, refresh, error } = await version(config.public.zigzagUrl)

const time = data.value ? data.value.t : 0;
const sha = data.value ? data.value.sha : 'versionnotfound';

const zigzagUrl = `${config.public.zigzagUrl}/app/layout/shell.html?sha=${sha}&t=${time}`;
const dataPage = `/reg-flow/avail-charts-lock?lid=${props.location.pulseId}&rgnad=true`

</script>
<template>
  <div :class="{ 'show-promo-banner': showPromoBanner }" class="www-pulseapp position-relative full-avc d-none d-md-block" :data-page="dataPage" id="www-spa-container" >
    <ClientOnly>
      <div class="pulseapp">
        <AngularSpinner />    
        <div class="shell-container" :ng-include="`'${zigzagUrl}'`">
          <div class="box-wrapper">
            
          </div>
        </div>
      </div>      
    </ClientOnly>
  </div>
</template>

<style lang="scss">
#location-page-components {
  idp-avc-availability-chart .av-sessions-header, idp-avc-availability-chart-virtual .av-sessions-header.align-items-stretch {
    top: 138px !important;
  }

  .show-promo-banner {
    idp-avc-availability-chart .av-sessions-header, idp-avc-availability-chart-virtual .av-sessions-header.align-items-stretch {
      top: 175px !important;
    }
  }

  idp-avc-availability-chart idp-avc-session-cell {
    background-color: white;
  }

  .full-avc {
    min-height: 300px;
    background-color: #d9d9d9;
    #global_spinner {
      position: relative !important;
      #spinner-message {
        top: 150px;
      }
    }
  }
} 
</style>